import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { useEffect, useState, useRef } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import { UserSummaryService } from '../../services/UserSummaryService';
import NumberFormatter from "../components/NumberFormatter";
import '../custom.css';
import { useLocation } from "react-router-dom";
import { isIOS } from '../../util/GeneralUtil';

function MasterSummary() {

    const pdfRef = useRef();
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const [summaryNetPosition, setSummaryNetPosition] = useState([]);
    const [date, setDate] = useState([]);
    const [week, setWeek] = useState([]);
    const [total, setTotal] = useState([]);
    const [name, setName] = useState([]);
    const [billTitle, setBillTitle] = useState([]);
    const [finalBillTotal, setFinalBillTotal] = useState([]);
    const [totalMasterAmount, setTotalMasterAmount] = useState([]);
    const [totalUplineAmount, setTotalUplineAmount] = useState([]);
    const [totalDownlineAmount, setTotalDownlineAmount] = useState([]);
    const [buyTotalAmount, setBuyTotalAmount] = useState([]);
    const [sellTotalAmount, setSellTotalAmount] = useState([]);
    const [bbrokerage, setBbrokerage] = useState([]);
    const [totalbrokerage, setTotalbrokerage] = useState([]);
    const { adminId, valan } = location.state || {};

    useEffect(() => {
        setLoading(true);
        UserSummaryService.getUserSummaryMasterBill({ adminId: adminId, valan: valan }).then((res => {
            setLoading(false);
            if (res.code === 1) {
                if (res.data?.summaryNetPosition?.length > 0) {
                    //setSummary(res.data.summaryNetPosition[0].summary);
                    setSummaryNetPosition(res.data.summaryNetPosition);
                    setDate(res.data?.summaryNetPosition[0]?.summary[0].valanDate);
                    setWeek(res.data?.summaryNetPosition[0]?.currentWeek);
                    setBillTitle(res.data?.summaryNetPosition[0]?.billTitle);
                }

                setName("(" + res.data?.admin?.userName + ")" + " " + res.data?.admin?.firstName);
                setTotal(res.data?.grandTotal);
                setTotalbrokerage(res.data?.totalBrokerage);
                setFinalBillTotal(res.data?.finalBillTotal);
                setBbrokerage(res.data?.brokerBrokerage);
                setTotalMasterAmount(res.data?.totalMasterAmount);
                setTotalUplineAmount(res.data?.totalUplineAmount);
                setTotalDownlineAmount(res.data?.totalDownlineAmount);
                setBuyTotalAmount(res.data?.buyAverageTotal);
                setSellTotalAmount(res.data?.sellAverageTotal);

            }
        }));
    }, [adminId]);

    const handlePrint = () => {
        const printContent = document.getElementById("printArea");
        const originalTitle = document.title;
        document.title = "masterbill_"+name+".pdf"; // Set the desired filenam
        const originalContent = document.body.innerHTML;
        
        document.body.innerHTML = printContent.innerHTML;;
        window.print();
        document.title = originalTitle;
        document.body.innerHTML = originalContent;
        window.location.reload(); // Reload the page to restore UI
      };

      
    const exportToPDF = () => {
        // const input = pdfRef.current;
        // html2canvas(input, { scale: 2 }).then((canvas) => {
        //     const imgData = canvas.toDataURL("image/png");
        //     const pdf = new jsPDF("p", "mm", "a4");
        //     const imgWidth = 210; // A4 width in mm
        //     const imgHeight = (canvas.height * imgWidth) / canvas.width; // Maintain aspect ratio
        //     const paddingTop = 20; // Space after the title
        //     pdf.setFontSize(12); // Set title font size
        //     pdf.text(process.env.REACT_APP_NAME, 105, 15, { align: "center" }); // Centered title
    
        //     pdf.addImage(imgData, "PNG", 0, paddingTop, imgWidth, imgHeight);
        //     pd
        // 
        // f.save("masterclientbill.pdf");
        // });

         UserSummaryService.getValanBill({ adminId: adminId, valan: valan }).then((res => {
                    setLoading(false);
                    if (res.code === 1) {
                        if(res.data.pdfData){
                            const pdf = new jsPDF();
                            const byteCharacters = atob(res.data.pdfData);
                            const byteNumbers = new Array(byteCharacters.length);
                            for (let i = 0; i < byteCharacters.length; i++) {
                                byteNumbers[i] = byteCharacters.charCodeAt(i);
                            }
                            const byteArray = new Uint8Array(byteNumbers);
                            const pdfBlob = new Blob([byteArray], { type: "application/pdf" });
                        
                            // Create a download link and trigger download
                            const link = document.createElement("a");
                            link.href = URL.createObjectURL(pdfBlob);
                            link.download = "masterclientbill_"+name+".pdf";
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                        }
                    }
                }))
    };

    return (
        <Card className='mb-5 white-row white-back zoom'>
            <Card.Body className='mb-4'>
                <Row>
                    <Col className='text-end mt-1'>
                        <Button variant="success" style={{ width: 80 }} onClick={isIOS ? handlePrint : handlePrint}>SAVE</Button>{' '}
                    </Col>
                </Row>
                {loading ? (
                    <div className="container vh-100">
                        <div className="d-flex align-items-center justify-content-center h-90">
                            <div className="spinner-border text-secondary m-5" role="status" style={{ width: '4rem', height: '4rem' }}>
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div ref={pdfRef} id="printArea" style={{ marginTop: "10px"}}>
                    <Table bordered className="mt-1" responsive style={{ marginBottom: 0 }}>
                        <thead>
                            <tr>
                            <th className='fss-14 white-back pt-1 pb-1 printFontFamily'>{billTitle}</th>
                            <th className='text-center fss-14 white-back pt-1 pb-1 printFontFamily'>{week}</th>
                            <th colSpan={2} className='text-end fss-14 white-back pt-1 pb-1 printFontFamily'>{date}</th>
                            </tr>
                            <tr>
                            <th colSpan={4} className='fss-14 text-black text-center white-back pt-1 pb-1 printFont'>{name}</th>
                            </tr>
                        </thead>

                        <tbody>
                            {summaryNetPosition.map((sum, index) => (
                            <tr key={index}>
                                <td colSpan={12} style={{ padding: 0, margin: 0 }}>
                                <Table>
                                    <tbody>
                                    <tr className='bg-thead'>
                                        <th colSpan={4} className='fss-14 text-white text-center pt-1 pb-1 printFont'>
                                        {"(" + sum.summary[0]?.summaryList[0]?.user?.userName + ") " + sum.summary[0]?.summaryList[0]?.user?.firstName}
                                        </th>
                                    </tr>

                                    {sum.summary.map((us, subIndex) => (
                                        <tr key={subIndex}>
                                        <td colSpan={12} style={{ padding: 0, margin: 0 }}>
                                            <Table hover key={subIndex} style={{ marginBottom: 0, borderCollapse: 'collapse' }} className='dotted-border'>
                                            <thead>
                                                <tr style={{ borderTop: "1px solid black" }}>
                                                <th colSpan={12} className='text-center text-black fss-14 pt-1 pb-1 printFont' style={{ backgroundColor: 'rgba(200, 212, 205, 0.91)' }}>
                                                    {us.summaryList[0]?.scriptName}
                                                </th>
                                                </tr>
                                            </thead>

                                            <thead className="netposition-header">
                                                <tr>
                                                <th className='text-black fss-14 pt-1 pb-1 printFontFamily'>Date Time</th>
                                                <th className="text-black text-center fss-14 pt-1 pb-1 printFontFamily">Type</th>
                                                <th className="text-black text-center fss-14 pt-1 pb-1 printFontFamily">Lot</th>
                                                <th className="text-black text-end fss-14 pt-1 pb-1 printFontFamily">Buy Qty</th>
                                                <th className="text-black text-end fss-14 pt-1 pb-1 printFontFamily">Sell Qty</th>
                                                <th className="text-black text-end fss-14 pt-1 pb-1 printFontFamily">Rate</th>
                                                <th className="text-black text-end fss-14 pt-1 pb-1 printFontFamily">Net Rate</th>
                                                <th className="text-black text-end fss-14 pt-1 pb-1 printFontFamily">Net Amount</th>
                                                </tr>
                                            </thead>

                                            <tbody className='fss-14'>
                                                {us.summaryList.map((item, itemIndex) => {
                                                const fontColorClass = item.netAmount > 0 ? 'positive-amout-color' : 'nagative-amout-color';
                                                return (
                                                    <tr key={itemIndex}>
                                                    <td className='text-black printFontFamily'>{item.executedDateTime}</td>
                                                    <td className="text-black text-center printFontFamily">{item.type}</td>
                                                    <td className="text-black text-center printFontFamily">{item.lot}</td>
                                                    <td className="text-end positive-amout-color printFontFamily">{item.buyQty || '-'}</td>
                                                    <td className="text-end nagative-amout-color printFontFamily">{item.sellQty || "-"}</td>
                                                    <td className="text-black text-end printFontFamily"><NumberFormatter number={item.rate} /></td>
                                                    <td className="text-black text-end printFontFamily"><NumberFormatter number={item.netRate} /></td>
                                                    <td className={`text-end printFontFamily ${fontColorClass}`}><NumberFormatter number={item.netAmount} /></td>
                                                    </tr>
                                                );
                                                })}

                                                {/* Script Wise Total Row moved into tbody */}
                                                <tr className='gray-row' style={{ borderBottom: "1px solid black" }}>
                                                <td colSpan={3} className='text-black removeborder'>Script Wise Total:</td>
                                                <td className='text-black text-end removeborder'>{us.totalBuyQty}</td>
                                                <td className='text-black text-end removeborder'>{us.totalSellQty}</td>
                                                <td className='text-black text-end removeborder'><NumberFormatter number={us.rate} /></td>
                                                <td className='text-black text-end removeborder'><NumberFormatter number={us.netRate} /></td>
                                                <td className='text-black text-end removeborder'><NumberFormatter number={us.netAmount} /></td>
                                                </tr>
                                            </tbody>
                                            </Table>
                                        </td>
                                        </tr>
                                    ))}

                                    {/* Final Summary moved into tbody */}
                                    <tr className='fss-14'>
                                        <td className='text-black'><span className='d-flex'>Total Gross: &nbsp; <NumberFormatter number={sum.grandTotal ?? 0} /></span></td>
                                        <td className='text-black'><span className='d-flex'>Total Brokerage: &nbsp; <NumberFormatter number={sum.totalBrokerage ?? 0} /></span></td>
                                        <td className='text-black'><span className='d-flex'>Broker Brokerage: &nbsp; <NumberFormatter number={sum.brokerBrokerage ?? 0} /></span></td>
                                        <td className='text-black'><span className='d-flex' style={{ float: "right" }}>
                                        <div style={{ display: "inline" }}>Final Bill Amt:&nbsp; </div>
                                        <div style={{ display: "inline" }} className={sum.finalBillTotal >= 0 ? "positive-amout-color" : "nagative-amout-color"}>
                                            <NumberFormatter number={sum.finalBillTotal ?? 0} />
                                        </div>
                                        </span></td>
                                    </tr>
                                    {billTitle === 'Live Bill' ? (
                                    <tr className='fss-14'>
                                        <td colSpan={2} className='text-black'><span className='d-flex'>Buy Turnover: &nbsp; <NumberFormatter number={sum.buyAverageTotal ?? 0} /></span></td>
                                        <td colSpan={2} className='text-black text-end'><span className='d-flex'>Sell Turnover: &nbsp; <NumberFormatter number={sum.sellAverageTotal ?? 0} /></span></td>
                                    </tr>) : ''}
                                    </tbody>
                                </Table>
                                </td>
                            </tr>
                            ))}

                            {/* Final Totals moved into tbody */}
                            <tr className='fss-14'>
                            <td className='text-black'><span className='d-flex'>Total Gross: &nbsp; <NumberFormatter number={total} /></span></td>
                            <td className='text-black'><span className='d-flex'>Total Brokerage: &nbsp; <NumberFormatter number={totalbrokerage} /></span></td>
                            <td className='text-black'><span className='d-flex'>Broker Brokerage: &nbsp; <NumberFormatter number={bbrokerage ?? 0} /></span></td>
                            <td className='text-black amount'><span className='d-flex' style={{ float: "right" }}>
                                <div style={{ display: "inline" }}>Final Bill Amt:&nbsp; </div>
                                <div style={{ display: "inline" }} className={finalBillTotal >= 0 ? "positive-amout-color" : "nagative-amout-color"}>
                                <NumberFormatter number={finalBillTotal} />
                                </div>
                            </span></td>
                            </tr>
                            {billTitle === 'Live Bill' ? (
                            <tr className='fss-14'>
                                <td colSpan={4} className='text-black text-center'><span className='d-flex align-items-center justify-content-center'>Total Master Amount: &nbsp; <NumberFormatter number={totalMasterAmount ?? 0} /></span></td>
                            </tr>) : (<>
                            <tr className='fss-14'>
                                <td colSpan={2} className='text-black'><span className='d-flex align-items-center justify-content-center'>Downline Master Amount : &nbsp; <NumberFormatter number={totalDownlineAmount ?? 0} /></span></td>
                                <td colSpan={2} className='text-black text-center'><span className='d-flex align-items-center justify-content-center'>Total Master Amount (Self): &nbsp; <NumberFormatter number={totalUplineAmount ?? 0} /></span></td>
                            </tr>
                            <tr className='fss-14'>
                                <td colSpan={2} className='text-black'><span className='d-flex align-items-center justify-content-center'>Buy Turnover: &nbsp; <NumberFormatter number={buyTotalAmount ?? 0} /></span></td>
                                <td colSpan={2} className='text-black text-end'><span className='d-flex align-items-center justify-content-center'>Sell Turnover: &nbsp; <NumberFormatter number={sellTotalAmount ?? 0} /></span></td>
                            </tr></>
                            )}
                            
                        </tbody>
                        </Table>

                    </div>
                )}
            </Card.Body>
        </Card>

    );

}
export default MasterSummary;